module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"entities.DeleteEntityTitle":"Delete {entityType}","entities.DeleteEntitySubtitle":"This {entityType} will be removed from this tenant. If this was a mistake you can re-invite them and their access will be renewed."}}')
  delete Component.options._Ctor
}
